import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: {
      email: null,
      auth0_id: null,
      full_name: null,
      avatar_url: null,
      token: null,
      lastLogin: null,
    },
  }),
  actions: {
    setUser(user) {
      this.user = { ...user, lastLogin: new Date().toISOString() };
    },
    logout() {
      this.user = {
        email: null,
        auth0_id: null,
        full_name: null,
        avatar_url: null,
        token: null,
        lastLogin: null,
      };
    },
  },
  getters: {
    isLoggedIn: (state) => {
      if (state.user && state.user.token) {
        const now = new Date();
        const lastLogin = new Date(state.user.lastLogin);
        const diffHours = (now - lastLogin) / (1000 * 60 * 60);

        if (diffHours < 24) {
          return true;
        } else {
          state.user = {
            email: null,
            auth0_id: null,
            full_name: null,
            avatar_url: null,
            token: null,
            lastLogin: null,
          };
          return false;
        }
      }
      return false;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "user",
        storage: localStorage,
      },
    ],
  },
});
